import React from 'react';
import {Link, useLocation} from 'react-router-dom';
import {motion} from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const {FiLayers, FiShield, FiHome, FiGrid, FiPaintBucket, FiTool} = FiIcons;

function ServicesNavigationFooter() {
  const location = useLocation();

  const services = [
    {
      icon: FiLayers,
      title: 'Trocken- und Akustikbau',
      shortTitle: 'Trockenbau',
      href: '/trockenbau' // NEUE URL auf erster Ebene
    },
    {
      icon: FiShield,
      title: 'Dämmtechnik',
      shortTitle: 'Dämmung',
      href: '/daemmtechnik' // NEUE URL auf erster Ebene
    },
    {
      icon: FiHome,
      title: 'Innentürmontage',
      shortTitle: 'Innentüren',
      href: '/innentuer' // NEUE URL auf erster Ebene
    },
    {
      icon: FiGrid,
      title: 'Bodenbelagsarbeiten',
      shortTitle: 'Bodenbelag',
      href: '/bodenbelag' // NEUE URL auf erster Ebene
    },
    {
      icon: FiPaintBucket,
      title: 'Maler- und Beschichtungsarbeiten',
      shortTitle: 'Maler',
      href: '/maler' // NEUE URL auf erster Ebene
    },
    {
      icon: FiTool,
      title: 'PU-Designböden (3D Optik)',
      shortTitle: '3D Böden',
      href: '/designboden' // NEUE URL auf erster Ebene
    }
  ];

  const isActive = (href) => location.pathname === href;

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Unsere Dienstleistungen
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Entdecken Sie unser komplettes Leistungsspektrum im Innenausbau und der Sanierung. 
            Qualität und Präzision in jedem Bereich.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {services.map((service, index) => (
            <motion.div
              key={service.href}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <Link
                to={service.href}
                className={`
                  group flex items-center space-x-4 p-6 rounded-xl transition-all duration-300 hover:shadow-lg hover:transform hover:scale-105
                  ${isActive(service.href)
                    ? 'bg-mk-teal-500 text-white shadow-lg transform scale-105'
                    : 'bg-white text-gray-700 hover:bg-mk-teal-50 hover:text-mk-teal-700'
                  }
                `}
                title={service.title}
              >
                <motion.div
                  whileHover={{ scale: 1.1, rotate: 5 }}
                  transition={{ type: "spring", stiffness: 300 }}
                  className={`
                    w-12 h-12 rounded-xl flex items-center justify-center transition-colors
                    ${isActive(service.href)
                      ? 'bg-white/20'
                      : 'bg-mk-teal-500 group-hover:bg-mk-teal-600'
                    }
                  `}
                >
                  <SafeIcon 
                    icon={service.icon} 
                    className={`w-6 h-6 ${isActive(service.href) ? 'text-white' : 'text-white'}`} 
                  />
                </motion.div>
                <div className="flex-1">
                  <h3 className={`
                    text-lg font-semibold mb-1
                    ${isActive(service.href) ? 'text-white' : 'text-gray-900 group-hover:text-mk-teal-700'}
                  `}>
                    {service.shortTitle}
                  </h3>
                  <p className={`
                    text-sm
                    ${isActive(service.href) ? 'text-white/80' : 'text-gray-600 group-hover:text-mk-teal-600'}
                  `}>
                    {service.title}
                  </p>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.6 }}
          viewport={{ once: true }}
          className="text-center"
        >
          <Link
            to="/services"
            className="inline-flex items-center space-x-2 bg-mk-red-700 hover:bg-mk-red-800 text-white px-8 py-3 rounded-sm font-semibold transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105"
          >
            <span>Alle Dienstleistungen im Detail</span>
            <motion.div
              whileHover={{ x: 3 }}
              transition={{ type: "spring", stiffness: 300 }}
            >
              <SafeIcon icon={FiTool} className="w-5 h-5" />
            </motion.div>
          </Link>
        </motion.div>
      </div>
    </section>
  );
}

export default ServicesNavigationFooter;